export const permissions = {
    ORDERS_CREATE: "ORDERS_CREATE",
    ORDERS_CREATE_SINGLE: "ORDERS_CREATE_SINGLE",
    ORDERS_HISTORY: "ORDERS_HISTORY",
    ORDERS_BORDERO: "ORDERS_BORDERO",
    ORDERS_LIST: "ORDERS_LIST",
    ORDERS_DISCARDED: "ORDERS_DISCARDED",
    ORDERS_RETURN: "ORDERS_RETURN",
    ORDERS_CREDIT: "ORDERS_CREDIT",
    TRACKING: "TRACKING",
    STORAGING: "STORAGING",
    COUNTERSIGN: "COUNTERSIGN",
    COURIER: "COURIER",
    MARKETPLACE: "MARKETPLACE",
    SETTINGS_COMPANY: "SETTINGS_COMPANY",
    SETTINGS_ADDRESS: "SETTINGS ADDRESS",
    SETTINGS_ADDRESS_SENDER: "SETTINGS_ADDRESS_SENDER",
    SETTINGS_ADDRESS_RECIPIENT: "SETTINGS_ADDRESS_RECIPIENT",
    SETTINGS_ADDRESS_RECIPIENT_USERNAME: "SETTINGS_ADDRESS_RECIPIENT_USERNAME",
    SETTINGS_PACKAGES: "SETTINGS_PACKAGES",
    SETTINGS_LABELS: "SETTING_LABELS",
    COMUNICATION: "COMUNICATION",
    WAREHOUSE_ORDERS_CREATE: "WAREHOUSE_ORDER_CREATE",
    WAREHOUSE_ORDERS_HISTORY: "WAREHOUSE_ORDERS_HISTORY",
    WAREHOUSE_STOCK: "WAREHOUSE_STOCK"
}

export const solutionPermissions = {
    ORDERS_CREATE: "ORDERS_CREATE",
    ORDERS_CREATE_SINGLE: "ORDERS_CREATE_SINGLE",
    ORDERS_HISTORY: "ORDERS_HISTORY",
    ORDERS_BORDERO: "ORDERS_BORDERO",
    ORDERS_LIST: "ORDERS_LIST",
    ORDERS_DISCARDED: "ORDERS_DISCARDED",
    ORDERS_RETURN: "ORDERS_RETURN",
    ORDERS_CREDIT: "ORDERS_CREDIT",
    TRACKING: "TRACKING",
    STORAGING: "STORAGING",
    COUNTERSIGN: "COUNTERSIGN"
}

export const ordersPermissions = {
    ORDERS_CREATE: "ORDERS_CREATE",
    ORDERS_CREATE_SINGLE: "ORDERS_CREATE_SINGLE",
    ORDERS_HISTORY: "ORDERS_HISTORY",
    ORDERS_BORDERO: "ORDERS_BORDERO",
    ORDERS_LIST: "ORDERS_LIST",
    ORDERS_DISCARDED: "ORDERS_DISCARDED",
    ORDERS_RETURN: "ORDERS_RETURN",
    ORDERS_CREDIT: "ORDERS_CREDIT"
};

export const connectionsPermissions = {
    COURIER: "COURIER",
    MARKETPLACE: "MARKETPLACE"
}

export const settingsSectionPermissions = {
    SETINGS_COMPANY: "SETTINGS_COMPANY",
    SETTINGS_ADDRESS: "SETTINGS ADDRESS",
    SETTINGS_ADDRESS_SENDER: "SETTINGS_ADDRESS_SENDER",
    SETTINGS_ADDRESS_RECIPIENT: "SETTINGS_ADDRESS_RECIPIENT",
    SETTINGS_ADDRESS_RECIPIENT_USERNAME: "SETTINGS_ADDRESS_RECIPIENT_USERNAME",
    SETTINGS_PACKAGES: "SETTINGS_PACKAGES",
    SETTINGS_LABELS: "SETTING_LABELS",
    COMUNICATION: "COMUNICATION"
}

export const settingsPermissions = {
    SETINGS_COMPANY: "SETTINGS_COMPANY",
    SETTINGS_ADDRESS: "SETTINGS ADDRESS",
    SETTINGS_ADDRESS_SENDER: "SETTINGS_ADDRESS_SENDER",
    SETTINGS_ADDRESS_RECIPIENT: "SETTINGS_ADDRESS_RECIPIENT",
    SETTINGS_ADDRESS_RECIPIENT_USERNAME: "SETTINGS_ADDRESS_RECIPIENT_USERNAME",
    SETTINGS_PACKAGES: "SETTINGS_PACKAGES",
    SETTINGS_LABELS: "SETTING_LABELS"
}

export const settingsAddressPermissions = {
    SETTINGS_ADDRESS_SENDER: "SETTINGS_ADDRESS_SENDER",
    SETTINGS_ADDRESS_RECIPIENT: "SETTINGS_ADDRESS_RECIPIENT",
    SETTINGS_ADDRESS_RECIPIENT_USERNAME: "SETTINGS_ADDRESS_RECIPIENT_USERNAME",
}

export const settingsAddressRecipientPermissions = {
    SETTINGS_ADDRESS_RECIPIENT: "SETTINGS_ADDRESS_RECIPIENT",
    SETTINGS_ADDRESS_RECIPIENT_USERNAME: "SETTINGS_ADDRESS_RECIPIENT_USERNAME",
}

export const warehousePermissions = {
    WAREHOUSE_ORDERS_CREATE: "WAREHOUSE_ORDER_CREATE",
    WAREHOUSE_ORDERS_HISTORY: "WAREHOUSE_ORDERS_HISTORY",
    WAREHOUSE_STOCK: "WAREHOUSE_STOCK"
}